// Click-to-load for embedded players. Loaded as a file, never inline: the CSP on client sites
// forbids inline scripts and `contract.mjs` checks the BUILT html for them.
//
// Until the visitor clicks, no request goes to YouTube, Vimeo or Spotify — which is the whole point:
// weight stays down and no third-party cookie is set before anyone agreed to anything.
(function () {
  document.addEventListener('click', function (event) {
    var figure = event.target.closest && event.target.closest('[data-sc-embed]');
    if (!figure || figure.dataset.scLoaded) return;
    var src = figure.getAttribute('data-src');
    if (!src) return;                       // no source: leave the link alone, it still works
    event.preventDefault();
    var frame = document.createElement('iframe');
    frame.setAttribute('src', src);
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', 'true');
    frame.setAttribute('loading', 'lazy');
    frame.setAttribute('title', figure.getAttribute('data-provider') || 'osadzony materiał');
    figure.innerHTML = '';
    figure.appendChild(frame);
    figure.dataset.scLoaded = '1';
  });
})();
